module.exports = __webpack_public_path__ + "static/media/hour.5eed6916.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carriere/resume/hour.svg
// module id = 274
// module chunks = 0